import React, { useState, useEffect } from 'react';
import { Table, Button, Switch, Card, message, Space, Spin, Tag } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import api from '../utils/api';

// 字段中文名映射
const FIELD_LABELS = {
  filter_use: '筛选使用',
  platform: '平台',
  handler: '受理员工',
  team: '小组',
  period: '期数',
  group_name: '群名',
  order_time: '下单时间',
  contact_person: '对接人',
  growth_method: '涨粉方式',
  account_name: '视频号名称/抖音号',
  text3: '文本3',
  link_type: '链接属性',
  exclusive_link: '专属链接/涨粉链接',
  account_duplicate: '账号重复',
  method_duplicate: '方式+账号重复',
  initial_fans: '初始粉丝数',
  final_fans: '涨粉后粉丝数',
  effective_fans: '最终有效粉',
  growth_count: '涨粉量',
  pre_growth_text: '涨粉前账号截图文字',
  post_growth_text: '涨粉完结截图文字',
  status_id: '完结状态',
  complete_date: '完成日期',
  remark: '备注',
  text1: '文本1',
  text2: '文本2',
  reference_price: '参考价格',
  actual_price: '实际价格',
  modified_by_name: '最新修改人'
};

function FieldPermission() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fields, setFields] = useState([]);
  const [supplierName, setSupplierName] = useState('');

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [fieldRes, supplierRes] = await Promise.all([
        api.get(`/suppliers/${id}/fields`),
        api.get(`/suppliers?page=1&pageSize=1000`)
      ]);

      if (fieldRes.code === 200) {
        setFields(fieldRes.data);
      }

      if (supplierRes.code === 200) {
        const supplier = supplierRes.data.list.find(s => s.id === parseInt(id));
        if (supplier) setSupplierName(supplier.name);
      }
    } catch (err) {}
    setLoading(false);
  };

  const handleToggle = (fieldName, key, checked) => {
    setFields(prev =>
      prev.map(f => {
        if (f.field_name !== fieldName) return f;
        const updated = { ...f, [key]: checked };
        // 不可见时自动设为不可编辑
        if (key === 'is_visible' && !checked) {
          updated.is_editable = false;
        }
        return updated;
      })
    );
  };

  const handleSelectAll = (key, value) => {
    setFields(prev => prev.map(f => ({ ...f, [key]: value })));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put(`/suppliers/${id}/fields`, {
        fields: fields.map(f => ({
          field_name: f.field_name,
          is_visible: f.is_visible,
          is_editable: f.is_editable
        }))
      });
      if (res.code === 200) {
        message.success('保存成功');
      }
    } catch (err) {}
    setSaving(false);
  };

  const columns = [
    {
      title: '字段名称',
      dataIndex: 'field_name',
      render: (v) => FIELD_LABELS[v] || v
    },
    {
      title: '字段标识',
      dataIndex: 'field_name',
      render: v => <Tag>{v}</Tag>
    },
    {
      title: '是否可见',
      dataIndex: 'is_visible',
      width: 100,
      render: (v, record) => (
        <Switch
          checked={v}
          size="small"
          onChange={(checked) => handleToggle(record.field_name, 'is_visible', checked)}
        />
      )
    },
    {
      title: '是否可编辑',
      dataIndex: 'is_editable',
      width: 100,
      render: (v, record) => (
        <Switch
          checked={v}
          size="small"
          onChange={(checked) => handleToggle(record.field_name, 'is_editable', checked)}
        />
      )
    }
  ];

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/suppliers')}>返回</Button>
          <h3 style={{ margin: 0 }}>字段权限配置 - {supplierName}</h3>
        </Space>
        <Space>
          <Button onClick={() => { handleSelectAll('is_visible', true); handleSelectAll('is_editable', true); }}>全部允许</Button>
          <Button onClick={() => handleSelectAll('is_visible', true)}>全部可见</Button>
          <Button onClick={() => handleSelectAll('is_visible', false)}>全部隐藏</Button>
          <Button onClick={() => handleSelectAll('is_editable', false)}>全部只读</Button>
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving}>保存配置</Button>
        </Space>
      </div>

      <Card>
        <p style={{ marginBottom: 16, color: '#666' }}>
          配置该主体的字段权限。「可见」控制主体能否看到该字段；「可编辑」控制主体能否修改该字段。
        </p>
        <Table
          rowKey="field_name"
          columns={columns}
          dataSource={fields}
          pagination={false}
          size="small"
        />
      </Card>
    </div>
  );
}

export default FieldPermission;
